import React from 'react';
import './Clients.css';
import businessman from '../Imges/Group 32.png';
import Clients2 from '../Componet/Clients2';
import OurSuccess2 from '../Componet/OurSuccess2';

const OurWorks = () => {
  return (
    <>
      <Clients2 />
      <OurSuccess2/>

    </>
  );
};

export default OurWorks;
